/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import css from 'styled-jsx/css';
import { colors, sizes, shadows } from '@styles/theme';

export default css.global`
  .ds-select-wrapper {
    font-size: ${sizes.base};
    padding: 0 ${sizes.base};
    margin-left: ${sizes.base};
    height: ${sizes.common};
    width: 260px;
    display: flex;
    align-items: center;
    position: relative;
    background-color: ${colors.white};
    box-shadow: ${shadows.lighterBlack};
    cursor: pointer;
    select {
      -moz-appearance: window;
      -webkit-appearance: none;
      position: absolute;
      overflow: hidden;
      height: 0;
      opacity: 0;
      z-index: -1;
      ::-ms-expand {
        display: none;
      }
    }
  }

  .ds-select {
    color: ${colors.secondary};
    border: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    > p {
      transition: border 0.35s ease-in-out;
    }
    span,
    .placeholder {
      color: ${colors.darkGrey};
      font-style: italic;
      margin-right: ${sizes.nano};
    }

    > svg {
      box-sizing: content-box;
      width: ${sizes.hecto};
      height: ${sizes.hecto};
      max-width: ${sizes.hecto};
      max-height: ${sizes.hecto};
      margin-left: 1rem;
      flex: 0 0 auto;
      align-self: center;
      color: ${colors.secondary};
      transition: transform 0.25s ease-out;
      background: transparent;
      pointer-events: none;
    }
    &.isOpen {
      svg {
        transform: rotate(360deg);
      }
      .ds-select-options-list {
        max-height: 400px;
      }
    }
    .ds-select-options-list {
      width: 260px;
      max-height: 0;
      padding: 0;
      margin: 0;
      position: absolute;
      top: calc(${sizes.common} + 1px);
      left: 0;
      overflow-y: auto;
      color: ${colors.secondary};
      background-color: ${colors.white};
      box-sizing: content-box;
      z-index: 2;
      font-size: 14px;
      line-height: 1.49;
      box-shadow: ${shadows.lighterBlack};
      transition: max-height 0.35s ease-in-out;
      > li {
        margin: 0 2px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > button {
          width: 100%;
          height: 100%;
          padding: 0;
          margin: 0;
          padding: ${sizes.base};
          cursor: pointer;
          font: ${`400 ${sizes.deka} 'Source Sans Pro', arial`};
          border: none;
          text-align: left;
          background-color: transparent;
        }
        :not(.headline):hover {
          background-color: ${colors.fairPink};
        }
        &.active,
        &:hover,
        &:active,
        &:focus {
          background-color: ${colors.fairPink};
        }
        .active {
          color: ${colors.white};
          font-weight: 600;
        }
        .headline {
          cursor: default;
          > p {
            font-weight: 600;
          }
        }
      }
    }
  }
`;
